import * as Sentry from "@sentry/astro";

export const fetchWithRetries = async <TData = unknown>(
  url: string,
  options: RequestInit,
  retries: number = 3,
  timeout: number = 5000,
) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    const controller = new AbortController();
    const signal = controller.signal;
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await fetch(url, { ...options, signal });
      const resultJson = await response.json();

      clearTimeout(timeoutId);
      return resultJson as TData;
    } catch (error) {
      clearTimeout(timeoutId);
      const status = (error as Error).cause;
      if (
        (typeof status === "number" && status >= 400 && status < 500) ||
        attempt === retries
      ) {
        Sentry?.captureMessage(
          `Failed to fetch ${options.method} ${url} ${
            options.body ? JSON.stringify(options.body) : ""
          } ERROR: ${(error as Error).message}`,
        );
        throw error;
      }
    }
  }

  throw new Error("Unexpected error in fetch");
};
